// Push известия (Expo → APNs/FCM): регистрира устройството след вход.
// На web и в симулатор без устройство просто не прави нищо.

import { Platform } from 'react-native';
import * as Device from 'expo-device';
import * as Notifications from 'expo-notifications';
import Constants from 'expo-constants';
import { api } from './api';
import { t } from './i18n';

Notifications.setNotificationHandler({
  handleNotification: async () =>
    ({
      shouldPlaySound: true,
      shouldSetBadge: false,
      shouldShowBanner: true,
      shouldShowList: true,
    }) as Notifications.NotificationBehavior,
});

export async function registerForPush(): Promise<void> {
  try {
    if (Platform.OS === 'web' || !Device.isDevice) return;

    if (Platform.OS === 'android') {
      await Notifications.setNotificationChannelAsync('default', {
        name: t('Известия'),
        importance: Notifications.AndroidImportance.HIGH,
        sound: 'default',
      });
    }

    const { status } = await Notifications.requestPermissionsAsync();
    if (status !== 'granted') return;

    const projectId: string | undefined = Constants.expoConfig?.extra?.eas?.projectId;
    const token = (await Notifications.getExpoPushTokenAsync(projectId ? { projectId } : undefined)).data;

    await api('/notifications/push-token', {
      body: { token, platform: Platform.OS === 'ios' ? 'ios' : 'android' },
    });
  } catch (e) {
    // без EAS projectId (или отказано разрешение) — просто без push, приложението работи
    console.log('[push] регистрацията е пропусната:', e);
  }
}
